<core-version-approval-form
    *ngIf="approval.approval_status=='pending' && !working"
    [version]="approval.version"
    [files]="approval.files"
    (onFileClick)="fileClick($event)"
    (onFileShow)="toggleShow($event)"
    (onAction)="onAction($event)">
</core-version-approval-form>

<core-version-approval-response
    *ngIf="approval.approval_status!='pending'"
    [approval]="approval">
</core-version-approval-response>

<core-helpers-box-loading [hidden]="!working"></core-helpers-box-loading>
